enum ItemFormats {
    Circle = 'Circle',
    Rectangle = 'Rectangle',
    Line = 'Line',
}

export default ItemFormats;
